
export default {
    // Please note that applying the .ag-tooltip class is very important;
    // otherwise, the tooltip doesn't position correctly at all (it's a disaster, TIAS!)
    template: `
        <div class="ag-tooltip" v-safe-html="tooltip"/>
    `,
    data() {
        return {
            tooltip: '',
        }
    },
    beforeMount() {
        this.tooltip = this.params.tooltip
    }
}